import { CLOSE_SIDEPANEL_EVENT_NAME } from '@/modules/scientific-analysis-module/components/scientific-analysis-summary/scientific-analysis-summary.models'
import { ScientificAnalysisFilterEntityType, ScientificAnalysisSearchEntityType } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'
import { scientificAnalysisService } from '@/modules/scientific-analysis-module/services/scientific-analysis-services'
import { ScientificAnalysis } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import { Vue, Component, Prop } from 'vue-property-decorator'
import ScientificAnalysisSummaryDetail from '@/modules/scientific-analysis-module/components/scientific-analysis-summary-detail/scientific-analysis-summary-detail.vue'

@Component({
    components: { ScientificAnalysisSummaryDetail }
})
export default class ScientificAnalysisSummary extends Vue {
    @Prop() scientificAnalysis!: ScientificAnalysis
    service = scientificAnalysisService

    get localizedEntityName(): string {
        if (this.scientificAnalysis.searchedEntityType !== null) {
            return this._getLocalizedEntityName(this.scientificAnalysis.searchedEntityType)
        } else {
            return ''
        }
    }

    onCloseClick() {
        this.$emit(CLOSE_SIDEPANEL_EVENT_NAME, false)
    }

    _getFilterIcon(filterEntityType: ScientificAnalysisFilterEntityType): string {
        return this.service.getFilterIcon(filterEntityType)
    }

    _getLocalizedEntityName(entity: ScientificAnalysisSearchEntityType | ScientificAnalysisFilterEntityType): string {
        return this.$t(`scientificAnalysis.entity.${entity}`) as string
    }
}
